import { AfterViewInit, Component, OnDestroy, OnInit, Optional, makeStateKey, TransferState } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { HiddenJob } from '@apply4u/Models/hidden-jobs';
import { JobSource } from '@apply4u/features/jobs/enums/job-source.enum';
import { BreadCrumb } from '@apply4u/models/breadcrumb';
import { JobPostingSchema } from '@apply4u/models/job-posting-schema';
import { JobStatistics } from '@apply4u/models/jobStatistics';
import { RecommendationModel } from '@apply4u/models/recommendation-model';
import { Job } from '@apply4u/models/search/job';
import { ResultsWithOutPagination } from '@apply4u/models/search/results-with-out-pagination';
import { BreadCrumbs, ListItem } from '@apply4u/models/seo/bread-crumbs';
import { ContextService } from '@apply4u/services/context-service';
import { JobapplicationService } from '@apply4u/services/jobapplication.service';
import { LoadingService } from '@apply4u/services/loading.service';
import { LocalstorageService } from '@apply4u/services/localstorage.service';
import { MasterDataService } from '@apply4u/services/masterdata.service';
import { MetaWrapperService } from '@apply4u/services/meta-wrapper.service';
import { JobSearchService } from '@apply4u/services/search/job-search.service';
import { SearchService } from '@apply4u/services/search/search.service';
import { ShowHideLogsService } from '@apply4u/services/showHideLogs.service';
import { SsrResponseService } from '@apply4u/services/ssr-response-service';
import { TalentMessengerService } from '@apply4u/services/talent-messenger/talent-messenger.service';
import { ToasterMessageService } from '@apply4u/services/toaster-message.service';
import { UserConnectionService } from '@apply4u/services/userConnection.service';
import { LoginTypeKeys } from '@apply4u/shared/constant/Local-storage-keys/login-type-keys';
import { Apply4U, Apply4ULogoUrl, Constant } from '@apply4u/shared/constant/constant';
import { BrowseJob_RouteUrl, JobsIn_RouteUrl, Jobs_RouteUrl } from '@apply4u/shared/constant/navigation/navigation';
import { ID, Title } from '@apply4u/shared/constant/navigation/query-param';
import { RecommendationType } from '@apply4u/shared/enums/recommendation-type.enum';
import { IsNotNumeric } from '@apply4u/shared/helpers/common/numeric-helpers';
import { QueryStringToJSON, ReplaceHyphenWithSpace, ToLowerCase, ToTitleCase } from '@apply4u/shared/helpers/common/string-helpers';
import { IsAny, IsNotAny, IsNotNull, IsNotNullOrEmpty, IsNotZero, IsNotZeroNumber, IsNull, IsNullOrEmpty } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { FormatSeoUrl } from '@apply4u/shared/helpers/seo-helper';
import { JobDetailUrlSmartPipe } from '@apply4u/shared/pipes/job-detail-url-smart.pipe';
import { environment } from '@environment/environment';
import { Location } from '@angular/common';
import { JobStatus as JobStatusEnum } from '@apply4u/shared/enums';
import { timer } from 'rxjs';

const STATE_KEY_SIMILAR_JOBS_RESUTLS = makeStateKey('SimilarJobsResutls');

@Component({
  templateUrl: './job-detail.component.html',
  styleUrls: ['./job-detail.component.css']
})
export class JobDetailComponent implements OnInit, OnDestroy {
  Job: Job;
  BackToSearchResultsUrl = null;
  WordsToHighlight = "";
  WishListJobId: number;
  PostUrl: string = "";
  RecommendationModel: RecommendationModel = new RecommendationModel();
  JobId: number = 0;
  JobSearchService: JobSearchService; 
  BreadCrumbsDisplayList: BreadCrumb[] = [];
  ParentSectorSeoName: string = '';
  QueryParams = {};
  JobSource = JobSource;
  RecommendationType = RecommendationType;
  RecommendedId: number;
  IsJobHidden: boolean = false;
  HiddenJobLog: HiddenJob[] = [];
  jobStatusEnum=JobStatusEnum;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private jobSearchService: JobSearchService,
    private localStorageService: LocalstorageService,
    private metaService: MetaWrapperService,
    private loadingService: LoadingService,
    public ContextService: ContextService,
    private toasterService: ToasterMessageService,
    private state: TransferState,
    private talentMessengerService: TalentMessengerService,
    private searchService: SearchService,
    private userConnectionService: UserConnectionService,
    public JobApplicationService: JobapplicationService,
    private masterDataService: MasterDataService,
    private showHideLogsService: ShowHideLogsService,
    private location: Location,
    @Optional() private ssrResponseService?: SsrResponseService) {
    this.WordsToHighlight = this.searchService.SearchParams.Keywords;
    this.JobSearchService = this.jobSearchService;
    this.GetBackToSearchResultUrl();
  }

  ngOnInit(): void {    
    this.InitializeJob();
  }

  InitializeJob(): void {
    this.activatedRoute.paramMap.subscribe((paramMap) => {
      this.activatedRoute.queryParamMap.subscribe(params => {
        if (params.has("searchhash") && IsNullOrEmpty(this.jobSearchService.SearchHash)) {
          this.jobSearchService.SearchHash = params.get("searchhash");
        }
      });

      this.JobId = (paramMap.has(ID)) ? parseInt(paramMap.get(ID)) : 0;
      this.localStorageService.SetItem("JobCardYAxis","Job-"+this.JobId);
      let paramTitle = paramMap.has(Title) ? paramMap.get(Title) : "";
      
      this.PopulateSearchParams(paramTitle);

      if (IsNotZero(this.JobId) || this.ContextService.IsClientSideLoading) {
        if (this.ContextService.IsClientSideLoading) {
          this.loadingService.Show();
        }

          this.jobSearchService.GetNewJob(this.JobId, this.jobSearchService.SearchHash).subscribe({
            next: job => {
              let todayDate = new Date();
              let displayEndDate = new Date(job?.DisplayEndDate);
              let displayEndDate1 = new Date(new Date(displayEndDate)?.setDate(displayEndDate.getDate() + 90));
              let displayEndDate2 = new Date(new Date(displayEndDate)?.setDate(displayEndDate.getDate() + 180));

              this.Job = job;           
              this.loadingService.Hide();

              if(this.Job.IsExpired){
                this.metaService.AddNoIndexMetaTag();
              }  
               
              if (IsNotNull(job) && (!job.IsExpired || displayEndDate1 >= todayDate)) {
                if (IsNotZero(this.JobApplicationService.QuickApplyJobId) && this.ContextService.IsUserLoggedIn) {
                  this.JobApplicationService.QuickApply(job);
                }
                                
                this.PopulateBreadCrumbsDisplayList();
    
                if (this.ContextService.IsSeoRequired) {
                  this.AddSeoMetaTags();                  
                }
    
                if (this.ContextService.IsBrowser && this.ContextService.IsUserLoggedIn) {
                  this.UpdateJobStatistics();
                  timer(6000).subscribe(() => {
                    this.talentMessengerService.LoadTalentMessengerWidget(window, this.Job.Id);
                  });
                }
              } else if (IsNotNull(job) && job.IsExpired && displayEndDate2 >= todayDate) {
                this.PopulateBreadCrumbsDisplayList(false);               
              } else {
                this.RedirectToSearchResults();
                }
            },
            error: error => {
              this.RedirectToSearchResults();
            }
          });

          // if(this.ContextService.IsUserLoggedIn){
          //   this.GetShowHideLogs(this.JobId);
          // }         
      }
    });

    if (this.ContextService.IsSeoRequired) {
      this.metaService.CreateCanonicalURL(this.metaService.GetCurrentPageURLWithoutQueryParams());
    }
  }

  PopulateSearchParams(paramTitle: string) {
    if (IsNotNullOrEmpty(paramTitle)) {
      let paramStringParts = [];

      paramStringParts = paramTitle.split("-jobs-in-");

      if (paramStringParts.length <= 1) {
        paramStringParts = paramTitle.split("jobs-in-");
      }

      if (paramStringParts.length <= 1) {
        paramStringParts = paramTitle.split("-jobs");
      }

      if (IsAny(paramStringParts)) {
        if (paramStringParts.length >= 1) {
          let keywords = "";
          let location = "";

          keywords = paramStringParts[0];
          location = paramStringParts[1];

          keywords = keywords.replace('-jobs', '');
          keywords = keywords.replace('-job', '');
          keywords = keywords.replace('-JOBS', '');
          keywords = keywords.replace('-JOB', '');
          keywords = keywords.replace('-Jobs', '');
          keywords = keywords.replace('-Job', '');
          keywords = keywords.replace(/-/g, ' ');
          keywords = keywords.replace(/\s\s+/g, ' ');

         // this.searchService.SearchParams.Keywords = this.WordsToHighlight = keywords;

          if (IsNotNullOrEmpty(location)) {
            let locationParts = location.split("-");

            if (IsNotNull(locationParts) && locationParts.length > 1) {
              this.searchService.SearchParams.Location = (location.replace(/-/g, ', '));
              this.searchService.SearchParams.Location = (this.searchService.SearchParams.Location.replace(/_/g, " "));
              this.searchService.SearchParams.Location = (this.searchService.SearchParams.Location.replace(/[{'}]/g, ")"));
              this.searchService.SearchParams.Location = (this.searchService.SearchParams.Location.replace(/[{~}]/g, '('));
            } else {
              this.searchService.SearchParams.Location = location.replace(/_/g, " ");
              this.searchService.SearchParams.Location = (this.searchService.SearchParams.Location.replace(/[{'}]/g, ")"));
              this.searchService.SearchParams.Location = (this.searchService.SearchParams.Location.replace(/[{~}]/g, '('));
            }
          }
        }
      }
    }
  }

  AddSeoMetaTags(): void {
    if (IsNotNull(this.Job)) {
      let wordsToSplit: string[] = [];

      if (IsNotNullOrEmpty(this.Job.Title)) {
        wordsToSplit = this.Job.Title.split("-");
      }

      if (IsAny(wordsToSplit) && IsNotNullOrEmpty(this.Job.LocationText)) {
        this.metaService.SetPageTitle(`${wordsToSplit[0]} job in ${this.Job.LocationText} | Jobs Near Me | Apply4U`);
        this.metaService.UpdateMetaTag('description', `View details and apply for this ${wordsToSplit[0]} job in ${this.Job.LocationText} on Apply4U. The only Job Site to Apply4U to 10 jobs a day!`);
      } else if (IsAny(wordsToSplit) && IsNullOrEmpty(this.Job.LocationText)) {
        this.metaService.SetPageTitle(`${wordsToSplit[0]} job | Apply4U`);
        this.metaService.UpdateMetaTag('description', `View details and apply for this ${wordsToSplit[0]} job on Apply4U, your helpful community jobsite. The only Job Site to Apply4U to 10 jobs a day!`);
      } else if (IsNotAny(wordsToSplit) && IsNotNullOrEmpty(this.Job.LocationText)) {
        this.metaService.SetPageTitle(`job in ${this.Job.LocationText} | Apply4U`);
        this.metaService.UpdateMetaTag('description', `View details and apply for job in ${this.Job.LocationText} on Apply4U. The only Job Site to Apply4U to 10 jobs a day!`);
      }

      if(this.Job.IsExpired){
        this.metaService.AddNoIndexMetaTag();
      }
    }
  }

  UpdateJobStatistics(): void {
    let loginbyAdmin = this.localStorageService.GetItem(LoginTypeKeys.LoginByAdminKey);

    if (IsNull(loginbyAdmin) || loginbyAdmin != "1") {
      let jobStatics = new JobStatistics();
      jobStatics.JobId = this.Job.Id;
      jobStatics.TotalViews = 1;
      jobStatics.UserId = this.ContextService.LoggedInUserId;
      jobStatics.Id = jobStatics.TotalApplications = 0;
      this.jobSearchService.SaveJobStatistics(jobStatics).subscribe(saveResult => {
      });
    }
  }

  SettingDataForLoadedScript(postingSchemaRequired: boolean = true): void {
    this.metaService.CreateBreadCrumbsScript(postingSchemaRequired ? JSON.stringify(this.GetJobPostingSchema()) : "", JSON.stringify(this.GetSEOBreadcrumbs()));
  }

  GetJobPostingSchema(): JobPostingSchema {
    let jobPostingSchema = new JobPostingSchema();

    jobPostingSchema.title = this.Job.Title;
    jobPostingSchema.identifier.value = this.Job.Id;
    jobPostingSchema.description = this.Job.Description;
    jobPostingSchema.datePosted = this.Job.DisplayStartDate;
    jobPostingSchema.validThrough = this.Job.DisplayEndDate;
    jobPostingSchema.baseSalary.value.minValue = this.Job.SalaryFrom;
    jobPostingSchema.baseSalary.value.maxValue = this.Job.SalaryTo;
    jobPostingSchema.jobLocation.address.streetAddress = "UNSPECIFIED";
    jobPostingSchema.image = `${environment.clientSideBaseUrl}${Apply4ULogoUrl}`;

    if (IsAny(this.Job.JobSectors)) {
      jobPostingSchema.industry = this.Job.JobSectors[0].Value;
    }

    if (IsNotNullOrEmpty(this.Job.JobType)) {
      jobPostingSchema.employmentType = this.Job.JobType.split(',')[0].trim();
    }

    if (IsNotNullOrEmpty(this.Job.LocationText)) {
      jobPostingSchema.jobLocation.address.addressLocality = this.Job.LocationText;
    }

    if (IsNotNullOrEmpty(this.Job.PostCode)) {
      jobPostingSchema.jobLocation.address.postalCode = this.Job.PostCode;
    }

    if (IsNotNullOrEmpty(this.Job.ParentLocationText)) {
      jobPostingSchema.jobLocation.address.addressRegion = this.Job.ParentLocationText;
    }

    if (IsNotNullOrEmpty(this.Job.SalaryDuration)) {
      jobPostingSchema.baseSalary.value.unitText = this.Job.SalaryDuration;
    }

    if (IsNotNullOrEmpty(this.Job.CompanyName)) {
      jobPostingSchema.hiringOrganization.name = this.Job.CompanyName;
    } else {
      jobPostingSchema.hiringOrganization.name = Apply4U;
    }

    if (IsNotNullOrEmpty(this.Job.LogoUrl)) {
      jobPostingSchema.hiringOrganization.logo = `${environment.BaseUrl}${this.Job.LogoUrl}`;
    } else {
      jobPostingSchema.hiringOrganization.logo = `${environment.clientSideBaseUrl}${Constant.Apply4ULogoUrl}`;
    }

    return jobPostingSchema;
  }

  OnWishListChange(isWishListed: boolean): void {
    this.Job.IsShortListed = isWishListed;
  }

  OnWishListIconClick(): void {
    let tagetElements = document.getElementsByClassName("btnWishList");

    if (this.ContextService.IsUserLoggedIn) {
      for (var i = 0; i < tagetElements.length; i++) {
        tagetElements[i].setAttribute("data-target", "#JobWishListModal");
      }

      this.WishListJobId = this.Job.Id;
    } else {
      this.toasterService.LoginMessageError();

      for (var i = 0; i < tagetElements.length; i++) {
        tagetElements[i].setAttribute("data-target", "");
      }
    }
  }

  OnShareJobClick(): void {
    let tagetElements = document.getElementsByClassName("btnShareJob");

    if (this.ContextService.IsUserLoggedIn) {
      if (this.Job.Id == 0) {
        this.PostUrl = this.Job.ApplicationURL;
      } else {
        let pipe = new JobDetailUrlSmartPipe();
        this.PostUrl = pipe.transform(this.Job.Title, this.Job.Id);
      }


      for (var i = 0; i < tagetElements.length; i++) {
        tagetElements[i].setAttribute("data-target", "#ShareJobModal");
      }
      this.SendRecommendation();
    } else {
      this.toasterService.LoginMessageError();

      for (var i = 0; i < tagetElements.length; i++) {
        tagetElements[i].setAttribute("data-target", "");
      }
    }
  }

  SendRecommendation(): void {
    this.RecommendationModel = new RecommendationModel();
    this.RecommendationModel.RecommendedId = this.Job.Id;
    this.RecommendationModel.RecommendedbyUserId = this.ContextService.LoggedInUserId;
    this.RecommendationModel.Title = "Job";
  }

  ConnectToUserClick(): void {
    this.userConnectionService.ConnectToJobPostedUser(this.Job);
  }

  OnDeleteConnectionRequestClick(): void {
    this.userConnectionService.CancelConnectionRequestWithJobPostedUser(this.Job);
  }

  ngOnDestroy(): void {
    if (this.ContextService.IsBrowser) {
      this.talentMessengerService.RemoveTalentMessengerWidget();
      this.metaService.RemoveNoIndexMetaTag();
    }
  }

  OnReportMisuseLink() {
    if (this.ContextService.IsUserLoggedIn) {
      this.jobSearchService.ReportMisUse(this.JobId, this.ContextService.LoggedInUserId).subscribe(saveResult => {
      });
      
      this.toasterService.Success(null, "Link is reported successfully. Our support team will look into this. Thank you");
    }
    else {
      this.toasterService.LoginMessageError();
    }
  } 

  PopulateBreadCrumbsDisplayList(postingSchemaRequired: boolean = true): void {
    this.BreadCrumbsDisplayList = [];
    let sectorName = null;
    let browseItem = new BreadCrumb();

    browseItem.Title = "Browse Jobs";
    browseItem.Url = BrowseJob_RouteUrl;
    this.BreadCrumbsDisplayList.push(browseItem);

    if (IsNotNullOrEmpty(this.Job.Title) && IsNotNumeric(this.Job.Title)) {
      sectorName = this.GetFormattedString(ToLowerCase(this.Job.Title));
    }

    if (IsNotNullOrEmpty(sectorName)) {
      let seoSectorName = FormatSeoUrl(sectorName);

      if (IsNotNullOrEmpty(seoSectorName)) {
        this.masterDataService.GetParentSectorByChildSectorName(seoSectorName).subscribe(sectorResult => {
          if (IsNotNull(sectorResult)) {
            this.AddSectorBreadCrumb(sectorResult.SectorName);

            if (ToLowerCase(sectorResult.SectorName) != ToLowerCase(sectorName)) {
              this.AddSectorBreadCrumb(sectorName);
            }

            if (this.ContextService.IsSeoRequired) {
              this.SettingDataForLoadedScript(postingSchemaRequired);
            }
          } else {
            this.SetDefaultSectorBreadCrumbs(sectorName, postingSchemaRequired);
          }
        }, errorResult => {
          this.SetDefaultSectorBreadCrumbs(sectorName, postingSchemaRequired);
        });
      }
    }
  }

  SetDefaultSectorBreadCrumbs(sectorName: string, postingSchemaRequired: boolean) {
    let defaultSector = "";

    if (IsAny(this.Job.JobSectors)) {
      defaultSector = this.Job.JobSectors[0].Value;
      this.AddSectorBreadCrumb(defaultSector);
    }

    if (defaultSector.toLocaleLowerCase() != sectorName.toLocaleLowerCase()) {
      this.AddSectorBreadCrumb(sectorName);
    }

    if (this.ContextService.IsSeoRequired) {
      this.SettingDataForLoadedScript(postingSchemaRequired);
    }
  }

  AddSectorBreadCrumb(sectorName: string) {
    let breadcrumb = new BreadCrumb();

    breadcrumb.Title = ToTitleCase(ReplaceHyphenWithSpace(sectorName));
    breadcrumb.Url = `${Jobs_RouteUrl}/${FormatSeoUrl(sectorName.toLocaleLowerCase())}-jobs`;
    this.BreadCrumbsDisplayList.push(breadcrumb);
  }

  AddLocationBreadCrumb(locationName: string) {
    let breadcrumb = new BreadCrumb();

    breadcrumb.Title = ToTitleCase(ReplaceHyphenWithSpace(locationName));
    breadcrumb.Url = `${JobsIn_RouteUrl}${FormatSeoUrl(locationName.toLocaleLowerCase())}`;
    this.BreadCrumbsDisplayList.push(breadcrumb);
  }

  AddCurrentBreadCrumb(sectorName: string) {
    let breadcrumb = new BreadCrumb();

    breadcrumb.Title = ToTitleCase(ReplaceHyphenWithSpace(sectorName));
    breadcrumb.Url = this.router.url.split('?')[0];
    this.BreadCrumbsDisplayList.push(breadcrumb);
  }

  GetFormattedString(searchWords: string) {
    searchWords = searchWords.replace(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/g, " ");
    searchWords = searchWords.replace(/\s+/g, ' ').trim();

    return searchWords;
  }

  GetSEOBreadcrumbs(): BreadCrumbs {
    let breadcrumbSchema = new BreadCrumbs();

    if (IsAny(this.BreadCrumbsDisplayList)) {
      let position = 1;

      this.BreadCrumbsDisplayList.forEach(item => {
        let homeItem = new ListItem();

        homeItem.position = position;
        homeItem.name = item.Title.toLocaleLowerCase();
        homeItem.item = `${environment.HostName}${item.Url.toLocaleLowerCase()}`;
        breadcrumbSchema.itemListElement.push(homeItem);

        position += 1;
      });
    }

    return breadcrumbSchema;
  }

  GetBackToSearchResultUrl(): void {
    let searchUrlParts = this.searchService.GetJobSearchUrl().split('?');

    if (IsAny(searchUrlParts)) {
      this.BackToSearchResultsUrl = searchUrlParts[0];

      if (searchUrlParts.length > 1) {
        this.QueryParams = QueryStringToJSON(searchUrlParts[1]);
      }
    }
  }
  
  RedirectToSearchResults(): void {
    let urlParts = decodeURIComponent(this.router?.url)?.split('/');

    if (IsAny(urlParts)) {
      urlParts.pop();
      let searchResultsUrl = urlParts.join('/');

      if (this.ContextService.IsBrowser) {
        this.router.navigateByUrl(searchResultsUrl);
      } else {
        this.ssrResponseService.PermanentRedirect(searchResultsUrl);
      }
    }
  }

  OnRecommendationChange(isExist: boolean): void {
    this.Job.IsRecommended = isExist;
  }

  OnRecommendationIconClick(jobId: number): void {
    let tagetElements = document.getElementsByClassName(`btnRecommendationList`);

    if (this.ContextService.IsUserLoggedIn) {
      for (var i = 0; i < tagetElements.length; i++) {
        tagetElements[i].setAttribute("data-target", "#RecommendedListModal");
      }
      
      this.RecommendedId = jobId;
    } else {
      this.toasterService.LoginMessageError();

      for (var i = 0; i < tagetElements.length; i++) {
        tagetElements[i].setAttribute("data-target", "");
      }
    }
  }

  GetShowHideLogs(jobId: number, isUnhideJob: boolean = false): void {
    this.loadingService.Show();
    this.showHideLogsService.GetHiddenJobs(this.ContextService.LoggedInUserId, 1, 10).subscribe({
      next: hiddenJob => {
        this.loadingService.Hide();
        this.HiddenJobLog = hiddenJob.Response.filter(x => x.Id == jobId);

        if (IsAny(this.HiddenJobLog)) {
          if (isUnhideJob) {
            this.showHideLogsService.SaveUnhideJobInfo(this.HiddenJobLog[0].ShowHideLogId);
            this.IsJobHidden = false;
          } else {
            this.IsJobHidden = true;
          }
        }
      }, error: error => {
        this.loadingService.Hide();
      }
    });
  }

  HideJobClick(job: Job): void {
    if (this.ContextService.IsUserLoggedIn) {
      this.showHideLogsService.SaveHideJobInfo(job);
      this.IsJobHidden = true;
      this.HiddenJobLog = [];
      this.location.back();
    } else {
      this.toasterService.LoginMessageError();
    }
  }

  UnhideJobClick(jobId: number) {
    if (this.ContextService.IsUserLoggedIn) {
      if (IsNotZeroNumber(jobId)) {
        this.GetShowHideLogs(jobId, true);
      }
    } else {
      this.toasterService.LoginMessageError();
    }
  }
}
